import { q, qq } from "../../helper/q"
import Cookies from "js-cookie"
export const notificationInit = () => {
  const notifications = qq(".warning")
  const getCookies = Cookies.getJSON("alert") || []

  notifications.map(notification => {
    const id = notification.id
    const closeButton = q(".warningClose", notification)
    if (!getCookies.some(exitId => exitId === id)) {
      notification.classList.add("warningShow")
    }
    closeButton.addEventListener("click", () => {
      if (!getCookies.some(exitId => exitId === id)) {
        Cookies.set("alert", [...getCookies, id])
        notification.classList.remove("warningShow")
      }
    })
  })
}
